import {  handleEditable } from '../../handlers';
import { spliceArray, updateSectionData } from '../../handlers/utils';
import { runAxios } from '../../handlers/axios';
import { getUsefulVars } from '../../handlers/helpers';


/**
 *
 * @param newBulletData
 * @param stateProps
 * @param stopRerender
 */
export const updateBulletData = (newBulletData, stateProps, stopRerender) => {
  let rerenderToggle = !stateProps.bulletData.rerenderToggle;
  rerenderToggle = stopRerender ? stateProps.bulletData.rerenderToggle : rerenderToggle;
  stateProps.setBulletData({
    bullets: getBulletDataProperty(newBulletData, stateProps, 'bullets'),
    unselectedBullets: getBulletDataProperty(newBulletData, stateProps, 'unselectedBullets'),
    selectedBullets: getBulletDataProperty(newBulletData, stateProps, 'selectedBullets'),
    bulletsFound: getBulletDataProperty(newBulletData, stateProps, 'bulletsFound'),
    bulletsLoading: getBulletDataProperty(newBulletData, stateProps, 'bulletsLoading'),
    bulletError: getBulletDataProperty(newBulletData, stateProps, 'bulletError'),
    bulletGroup: getBulletDataProperty(newBulletData, stateProps, 'bulletGroup'),
    bulletModal: getBulletDataProperty(newBulletData, stateProps, 'bulletModal'),
    bulletValue: getBulletDataProperty(newBulletData, stateProps, 'bulletValue'),
    rerenderToggle: rerenderToggle,
  });
};

export const setSelectedBullets = (jobSeekerData, selectedBullets, stateProps) => {
  const sectionIndex = stateProps.sectionData.sectionIndex;
  jobSeekerData[sectionIndex]['bulletsb'] = selectedBullets;
  updateBulletData({ selectedBullets: selectedBullets }, stateProps);
};
export const freeFormEdit = (e,option,jobseekerData,sectionIndex,stateProps) => {
  const newLabel = e.currentTarget.value;
  option.label = newLabel;
  const bullets = jobseekerData[sectionIndex]['bulletsb'];
  for(const bullet of bullets){
    if(bullet.key === option.key){
      bullet.label = newLabel;
    }
  }
  updateBulletData({
    selectedBullets: bullets,
  }, stateProps);

}
const fetchBulletsCallback = (result, args) => {
  const props = args.props;
  const stateProps = props.stateProps;
  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const bullets = JSON.parse(result.data);
  const secOrIndIndex = args.secOrIndIndex;
  const step = args.step;
  const finalStep = args.finalStep;
  const industry = args.industry;
  const newUnselectedBullets = JSON.parse(JSON.stringify(bullets));

  /** remove selected recommended bullets from unselected list */
  const bulletsToRemoveFromUnselected = [];
  //@todo are there ever any bullets here
  for (const jBullet of jobSeekerData[secOrIndIndex]['bulletsb']) {
    for (const newUnselectedBullet of newUnselectedBullets['recommended']) {
      if (jBullet.key === newUnselectedBullet.key) {
        bulletsToRemoveFromUnselected.push(newUnselectedBullet);
      }
    }
  }

  let finalUnselectedBullets = [];
  finalUnselectedBullets = spliceArray(newUnselectedBullets['recommended'], bulletsToRemoveFromUnselected);
  newUnselectedBullets['recommended'] = finalUnselectedBullets;
  //end remove
  const sBullets = jobSeekerData[secOrIndIndex]['bulletsb'];

  let firstBulletGroup = 'generic';
  if (newUnselectedBullets['recommended'] > 0) {
    firstBulletGroup = 'recommended';
  }
  /*** two state updates **/
  updateBulletData({
    bulletsLoaded: true,
    bullets: bullets,
    unselectedBullets: newUnselectedBullets,
    selectedBullets: sBullets,
    bulletGroup: firstBulletGroup,
  }, stateProps);


  if (finalStep === true) {
    updateSectionData({
      sectionType: 'industry',
      industryType: industry,
      indIndex: secOrIndIndex,

    }, stateProps);
    handleEditable(stateProps, secOrIndIndex, step);
  }
  updateSectionData({
    sectionType: 'industry',
    industryType: industry,
    indIndex: secOrIndIndex,

  }, stateProps);
  handleEditable(stateProps, secOrIndIndex, step);
};
//which index is this.
export const fetchBullets = (props, secOrIndIndex, step, finalStep = false) => {
  const stateProps = props.stateProps;
  const formikProps = props.formikProps;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const pe = stateProps.dataToSave.saved.resumes[resumeIndex]['professional-experience'][secOrIndIndex];
  const jobSeekerData = formikProps.values.jobSeekerData;
  if (typeof jobSeekerData[secOrIndIndex]['bulletsb'] === 'undefined') {
    jobSeekerData[secOrIndIndex]['bulletsb'] = [];
  }
  stateProps.bullets = [];
  const jobSeekerIndustry = typeof pe['industry'] !== 'undefined' ? pe['industry'][0] : '';
  //@todo: is this necessary or already set.
  const industry = typeof stateProps.dataToSave.industry[jobSeekerIndustry] !== 'undefined' ? jobSeekerIndustry : 'other';
  const jobTitle = typeof pe['job_title'] !== 'undefined' ? pe['job_title'] : '';
  const url = stateProps.domain + '/wp-json/rsworks/v1/bullets';
  const request = { id: industry, job_title: jobTitle, job_index: secOrIndIndex };
  //end init
  //fetch bullets from server
  const args = {
    props: props,
    message: 'Fetch Bullets from AI',
    industry: industry,
    secOrIndIndex: secOrIndIndex,
    step: step,
    finalStep: finalStep,
  };
  runAxios(url, request, fetchBulletsCallback, args);
};

export const processBullets = (bullets, jobSeekerData, jobIndex, targetGroup = null) => {
  if (targetGroup) {
    if (targetGroup.length > 0) {
      processBulletGroup(targetGroup, jobSeekerData, jobIndex);
    } else {
      return bullets;
    }
  } else {
    bullets.forEach((bulletGroup) => {
      if (bulletGroup !== null) {
        processBulletGroup(bulletGroup, jobSeekerData, jobIndex);
      }
    });

  }
  return bullets;
};

export const addFreeFormBullet = (stateProps) => {
  const unselectedBullets = stateProps.bulletData.unselectedBullets;
  const selectedBullets = stateProps.bulletData.selectedBullets;
  const keyPart = getLastFreeFormBullet(unselectedBullets, selectedBullets);
  const newFreeFormBullet = {
    'label': '~',
    'key': 'ff-' + keyPart,
    'type': 'freeform',
    'questions': [],
    'origMatches': [
      [
        '{{add text}}',
      ],
    ],
    'qid': 'add text',
    'buttonLabels': [
      [
        'add text',
      ],
    ],
  };
  unselectedBullets['freeform'].push(newFreeFormBullet);
  stateProps.setCounter(stateProps.counter + 1);
};

/**
 *
 * @param newBulletData
 * @param stateProps
 * @param attrName
 * @returns {*}
 */
const getBulletDataProperty = (newBulletData, stateProps, attrName) => {
  return typeof newBulletData[attrName] !== 'undefined' ? newBulletData[attrName] : stateProps.bulletData[attrName];
};

/**
 *
 * @param bulletIds
 * @param jobSeekerData
 * @param jobIndex
 * @returns {*[]}
 *
 */
const processButtonLabels = (bulletIds, jobSeekerData, jobIndex) => {
  const buttonLabels = [];

  bulletIds.forEach((bulletId) => {
    bulletId[0] = bulletId[0].substring(bulletId[0].indexOf('{{') + 2, bulletId[0].indexOf('}}'));
    if (typeof jobSeekerData[jobIndex][bulletId[0]] !== 'undefined') {
      bulletId[0] = jobSeekerData[jobIndex][bulletId[0]];
    }
    buttonLabels.push(bulletId);
  });
  return buttonLabels;
};

/**
 *
 * @param buttonLabel
 * @returns {*[]}
 */
const extractButtonIdsFromButtonLabel = (buttonLabel) => {
  let buttonIds = [];
  if (buttonLabel.indexOf('{{') >= 0) {
    buttonIds = [...buttonLabel.matchAll(RegExp('\\{{.*?\\}\\}', 'g'))];
  }
  return buttonIds;
};
/**
 *
 * @param bulletGroup
 * @param jobSeekerData
 * @param jobIndex
 */
const processBulletGroup = (bulletGroup, jobSeekerData, jobIndex) => {
    if (bulletGroup.length > 0) {
      bulletGroup.forEach((option) => {
        const bulletIds = extractButtonIdsFromButtonLabel(option.label);
        option.origMatches = extractButtonIdsFromButtonLabel(option.label);

        //set option labels to be either the original placeholder or if it has changed the new placeholder
        if (option.origMatches !== null) {
          option.origMatches.forEach((origBulletPlaceholder) => {
            const placeholder = typeof jobSeekerData[jobIndex][origBulletPlaceholder] !== 'undefined' ? jobSeekerData[jobIndex][origBulletPlaceholder] : origBulletPlaceholder;
            option.label = option.label.replace(placeholder, '~');

          });

        }

        //is this the same as above.
        if (bulletIds !== null && bulletIds.length > 0) {
          //legacy


          let qid = bulletIds[0][0].replace('{{', '');
          if (typeof option.qid === 'undefined') {
            qid.replace('}}', '');
          } else {
            option.origMatches[0][0] = option.qid;
          }
          /*
                  qid =bulletIds[0][0].replace('{','');
          option.qid = qid.replace('}','');*/
          option.buttonLabels = processButtonLabels(bulletIds, jobSeekerData, jobIndex);
          if (option.type === 'recommended') {
            option.buttonLabels[0][0] = option.qid;
          }
        }

      });
    }
  }
;

const getLastFreeFormBullet = (unselectedBullets, selectedBullets) => {
  const selectedFFBullets = [];
  for (const selectedBullet of selectedBullets) {
    if (selectedBullet.type === 'freeform') {
      selectedFFBullets.push(selectedBullet);
    }
  }
  const ffBullets = unselectedBullets['freeform'].concat(selectedFFBullets);
  const ffKeys = [];
  for (const ffBullet of ffBullets) {
    let newKeyRaw = ffBullet.key.split('-');
    ffKeys.push(newKeyRaw[1]);
  }
  let retVal = 1;
  if (ffKeys.length > 0) {
    ffKeys.sort();
    retVal = parseInt(ffKeys[ffKeys.length - 1]) + 1;
  }
  return retVal;
};


export const getIndustryPECallback = (result, args) => {

  const stateProps = args.props.stateProps;

  stateProps.setAIIndustryPEData({ aiIndustryQObj: result.data });
  args.props.stateProps.onJobIndustryOpen();
};
export const getIndustryPE = (props) => {
  const uv = getUsefulVars(props);
  uv.formikProps.validateForm().then((status) => {
      const sectionIndex = uv.stateProps.sectionData.sectionIndex;
      if (status.jobSeekerData !== undefined && status.jobSeekerData[sectionIndex] !== undefined) {
        return null;
      } else {
        const pe = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['professional-experience'][sectionIndex];
        const url = uv.stateProps.domain + '/wp-json/rsworks/v1/ai_industries';

        const request = {
          jobTitle: pe['job_title'],
        };
        const args = {
          props: props,
          message: 'Get Industries from AI',
        };

        uv.stateProps.setSpinnerMessage('');
        uv.stateProps.setSpinnerImage('default.gif');
        uv.stateProps.onSpinnerOpen();
        runAxios(url, request, getIndustryPECallback, args);
      }
    },
  );
};

export const nextToBulletBankCallback = (result, args) => {
  const uv = getUsefulVars(args.props);
  const step = args.step;

  const jobSeekerData = uv.formikProps.values.jobSeekerData;
  const sectionIndex = args.sectionIndex;
  const industry = args.industry;
  const data = { };
  data['generic'] =args.result.data;
  data['fillable'] =result.data;
  data['existing'] = uv.resume['professional-experience'][sectionIndex].existing;
  let newBullets = data;
  const industryQuestions = [];
  const savedSection = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex]['professional-experience'][sectionIndex]
  let savedBullets = savedSection['bulletsb'] !== undefined ? savedSection['bulletsb'] : [];
  const defaultQuestion = {
    entry_criteria: 'nolimit',
    index: 0,
    isIndustry: true,
    instructions: 'Review your personalized bullets below. You can then add more or swap them out using the searchable bullet bank on the right.',
    qid: 'bullets-bacon',
    question: 'Select Your Bullets',
    question_type: 'bullets',
    stype: 'detailed',
  };
  industryQuestions.push(defaultQuestion);


  uv.stateProps.dataToSave.industry.other = {};
  uv.stateProps.dataToSave.industry.other.questions = industryQuestions;
  const targetGroup = 'fillable';


  newBullets.freeform = [{
    'label': '{{add text}}',
    'key': 'ff-1',
    'type': 'freeform',
    'questions': [],
  }];
  newBullets['recommended'] = [];
  newBullets = processBullets(newBullets, jobSeekerData, sectionIndex, newBullets['freeform']);
  newBullets = processBullets(newBullets, jobSeekerData, sectionIndex, newBullets['fillable']);
  //newBullets = processBullets(newBullets, jobSeekerData, sectionIndex, newBullets['recommended']);
  updateBulletData({
    bulletsLoaded: true,
    bullets: newBullets,
    unselectedBullets: newBullets,
    selectedBullets: savedBullets,
    bulletGroup: targetGroup,
    bulletValue: {},
  }, uv.stateProps);


  updateSectionData({
    sectionType: 'industry',
    industryType: industry,
    sectionIndex: uv.stateProps.sectionData.sectionIndex,

  }, uv.stateProps);
  //jobSeekerData[sectionIndex]['bulletsb'] = savedBullets;
  const stepIndex = step === 'first' ? 0 : uv.stateProps.dataToSave.industry.other.questions.length - 1;
  uv.stateProps.setSpinnerImage('default.gif');
  uv.stateProps.setSpinnerMessage('');
  uv.stateProps.onSpinnerClose();
  handleEditable(uv.stateProps, sectionIndex, stepIndex);

};
export const nextToBulletBank = (props, secOrIndIndex) => {
  const stateProps = props.stateProps;
  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const indIndex = secOrIndIndex;//stateProps.sectionData.indIndex;
  const target_industry = stateProps.dataToSave.saved.resumes[resumeIndex]['industry'];
  const target_job_title = stateProps.dataToSave.saved.resumes[resumeIndex]['job_title'];
  const job_title = jobSeekerData[indIndex]['job_title'];
  const industry = jobSeekerData[indIndex]['industry'];
  const url = stateProps.domain + '/wp-json/rsworks/v1/getGenericBullets';
  const sectionIndex = stateProps.sectionData.sectionIndex;

  const request = {
    job_title: job_title,
    industry: industry,
    targetJobTitle: target_job_title,
    targetIndustry: target_industry[0],
  };
  const args = {
    props: props,
    sectionIndex: sectionIndex,
    resumeIndex:resumeIndex,
    industry: industry,
  };
  stateProps.setSpinnerMessage('We\'re pulling your details into one polished resume.');
  stateProps.setSpinnerImage('next.gif');
  stateProps.onSpinnerOpen();
  runAxios(url, request,getFillableCallback, args);


};

const getFillableCallback = (result,args) => {
  const url = args.props.stateProps.domain + '/wp-json/rsworks/v1/getFillableBullets';
  const request = {
    jobTitle: args.job_title,
    industry: args.industry,
    targetJobTitle: args.target_job_title,
    targetIndustry: args.target_industry,
    jobExperience: args.jobExperience,
  };
  args.result = result;
  args.props.stateProps.setSpinnerMessage('We\'re pulling your details into one polished resume.');
  args.props.stateProps.setSpinnerImage('bullets.gif');
  runAxios(url, request, nextToBulletBankCallback, args);

}
